import React, { useMemo } from "react";
import { Progress } from "antd";
import { isEmpty } from "lodash";
import Function from "./Functions";
const { FormateNumber } = Function;
function ProgressBar({ data }) {
	let { percent, total, loaded, abbr } = useMemo(() => {
		if (!isEmpty(data)) {
			const { total, loaded = 0, divisor, percent, abbr } = data;
			if (divisor)
				return { percent, total: (total / divisor).toFixed(1), loaded: (loaded / divisor).toFixed(1), abbr };
			else return { percent, total, loaded, abbr };
		} else {
			return { percent: null, abbr: "-", loaded: 0 };
		}
	}, [data]);

	return (
		<>
			{(percent !== null && (
				<div
					style={{
						display: "flex",
						height: "21px"
					}}
				>
					<div
						style={{
							width: "80%"

							// backgroundColor: "lightblue"
						}}
					>
						<Progress percent={percent} />
					</div>
					<div
						style={{
							minWidth: "20%",
							flexShrink: 0
						}}
						className="mt-1 pl-2"
					>
						<span>{`${FormateNumber(loaded)}/${FormateNumber(total)} ${abbr}`}</span>
					</div>
				</div>
			)) || <spn>{abbr}</spn>}
		</>
	);
}

export default ProgressBar;
